import { ANSWER_TYPES, LANGUAGES } from './constants'
import { questionsConfig } from './questions'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const alternativesRenderConfig = {
  leftImage: {
    type: 'custom',

    label: {
      [PORTUGUESE]: 'Imagem na Esquerda',
      [ENGLISH]: 'Left Image',
      [SPANISH]: 'Imagem na Esquerda',
    },

    renderChecker: question => {
      const { type } = question

      const { answerConfig } = questionsConfig[type]

      return answerConfig.extraOptions.includes('leftImage')
    },
  },

  rightImage: {
    type: 'custom',

    label: {
      [PORTUGUESE]: 'Imagem na Direita',
      [ENGLISH]: 'Right Image',
      [SPANISH]: 'Imagem na Direita',
    },

    renderChecker: question => {
      const { type } = question

      const { answerConfig } = questionsConfig[type]

      return answerConfig.extraOptions.includes('rightImage')
    },
  },

  onlyRenderWhen: {
    type: 'custom',

    label: {
      [PORTUGUESE]: 'Mostrar alternativa apenas se',
      [ENGLISH]: 'Only render if',
      [SPANISH]: 'Mostrar alternativa apenas se',
    },

    renderChecker: (question, alternativeType, questionGroups) => {
      const { type, qid } = question

      const allQuestions = questionGroups.map(({ questions }) => questions).flat()
      const currentIndex = allQuestions.findIndex(single => single.qid === qid)

      if (!currentIndex) return false

      const config = questionsConfig[type]

      const alternativeProp =
        alternativeType === ANSWER_TYPES.answers ? 'answerConfig' : 'subQuestionConfig'

      const { extraOptions } = config[alternativeProp]

      return extraOptions.includes('onlyRenderWhen')
    },
  },
}
